import { HttpBillSummaryList } from '@/service/chargescalc';
import TableList from "@components/templates/tablelist";
import { mapState, mapGetters } from 'vuex';
import comExcel from '../billdetail/excelalert.vue'
import compConfirmBill from './confirmbill.vue'
import mixin from "../mixin";

export default {
    mixins: [TableList, mixin],
    components: {
        comExcel,
        compConfirmBill
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpBillSummaryList,
        interceptRequest(params) {
            const billingDate = params.search['EQ_billingDate'] || ''
            const timeArray = billingDate.split(' ~ ');
            params.search.LE_startTime = timeArray[0];
            params.search.GE_endTime = timeArray[1];
            delete params.search.EQ_billingDate;
            return params
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case 'confirm':
                    this.operate = {
                        show: true,
                        alert: "info",
                        title: "确认账单",
                        width: 400,
                        params: {
                            id: params.id,
                            totalCost: params.totalCost,
                            type: 'billsummary'
                        },
                        component: "compConfirmBill",
                        showFooter: false,
                    };
                break;
                case "exportDetail":
                    this.exportDetail(params.billNo);
                break;
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/newBilling/billPayable/export', this.formData, {
                        executor: 'request',
                        download: true,
                        method: 'get',
                    })
                break;
            }
        },
        getOperateNodeMap(row) {
            // console.log(row)
            const { id, status, totalCost, billNo } = row;
            return [
                {
                    label: this.$t('fbb.billmanage.confirm_bill', { defaultValue: "确认账单" }),
                    show: status == 0,
                    params: {id, totalCost},
                    operate: 'confirm'
                },
                {
                    label: "导出明细",
                    show: true,
                    params:{ id, billNo },
                    operate:'exportDetail'
                },
            ]
        },
        exportDetail(billNo){
            const searchItem = { bill_no: billNo};
            this.handleWebfs(
                process.env.VUE_APP_APIURL_BI + "/api/v1/ReportTask/save",
                {args:JSON.stringify(searchItem), template_id: 10034},
                {
                    executor: "request",
                    download: true,
                    method: "post",
                }
            )
            .then((res) => {
                this.operate = {
                  title: '查询条件导出',
                  show: true,
                  width: 560,
                  component: "comExcel",
                  fileId: res.data.id,
                  showFooter: false
            }})
            .catch((err) => {
                // this.$VMessage.error(err.message);
            });
            // this.handleWebfs(
            //     process.env.VUE_APP_APIURL_BI + "/api/v1/ReportTask/save",
            //     { args:JSON.stringify(searchItem), template_id: 10027 },
            //     {
            //         executor: "request",
            //         download: true,
            //         method: "post",
            //     }
            // )
            // .then((res) => {})
            // .catch((err) => {});
            // this.handleWebfs(
            //     process.env.VUE_APP_APIURL_BI + "/api/v1/ReportTask/save",
            //     { args:JSON.stringify(searchItem), template_id: 10028 },
            //     {
            //         executor: "request",
            //         download: true,
            //         method: "post",
            //     }
            // )
            // .then((res) => {})
            // .catch((err) => {});
            // this.handleWebfs(
            //     process.env.VUE_APP_APIURL_BI + "/api/v1/ReportTask/save",
            //     { args:JSON.stringify(searchItem), template_id: 10029 },
            //     {
            //         executor: "request",
            //         download: true,
            //         method: "post",
            //     }
            // )
            // .then((res) => {})
            // .catch((err) => {});
        }
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getBillcusWareList', 'getUserManageWarehouseList']),
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.export', { defaultValue: "导出" }),
                    operate: "export",
                    theme: "gray",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    key: 'EQ_warehouseCode',
                    show: true,
                    tag: 'vSelect',
                    options: this.getUserManageWarehouseList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('fbb.billmanage.bill_no', { defaultValue: '账单编号' }),
                    key: 'EQ_billNo',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('', { defaultValue: "账单状态" }),
                    key: 'EQ_status',
                    tag: 'vSelect',
                    show:true,
                    options: [
                        { value: 0,label: '待确认'},
                        { value: 1,label: '已确认'}
                    ],
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('erp.b2border.payment_days',{defaultValue:'账期'}),
                    tag: 'vDatepicker',
                    key: 'EQ_billingDate',
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                    style: "width:250px",
                },
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    type: "index",
                    title: "No.",
                    width: 60,
                    align: "center",
                },
                {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    maxWidth: 90,
                    render: this.getOperateNodes
                },
                {
                    title: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    key: 'warehouseCode',
                },
                {
                    title: this.$t('fbb.billmanage.bill_no', { defaultValue: '账单编号' }),
                    key: 'billNo',
                },
                {
                    title: this.$t('erp.b2border.payment_days',{defaultValue:'账期'}),
                    sortable: true,
                    render: (h, {row})=>{
                        return <div>{row.startTime}~{row.endTime}</div>
                    }
                },
                {
                    title: this.$t('fbb.delivery.totalCost',{defaultValue:'账单总额'}),
                    key: 'totalCost',
                },
                {
                    title: '仓库作业费总额',
                    render: (h, { row }) => {
                        return <div>{row.operationCost || '--'}</div>
                    }
                },
                {
                    title: '仓储费总额',
                    render: (h, { row }) => {
                        return <div>{row.storageCost || '--'}</div>
                    }
                },
                {
                    title: '增值服务费总额',
                    render: (h, { row }) => {
                        return <div>{row.valueAddedCost || '--'}</div>
                    }
                },
                {
                    title: '调账总额',
                    render: (h, { row }) => {
                        return <div>{row.adjustmentCost || '--'}</div>
                    }
                },
                {
                    title: this.$t('global.common.currency', { defaultValue: '币种' }),
                    key: 'currency'
                },
                {
                    title: this.$t('', { defaultValue: "账单状态" }),
                    render: (h,{row})=>{
                        return <div>{row.status == 1 ? '已确认' : '待确认'}</div>
                    }
                },
                {
                    title: this.$t('', { defaultValue: '确认人' }),
                    key: 'confirmBy'
                },
                {
                    title: this.$t('', { defaultValue: '确认时间' }),
                    key: 'confirmAt'
                },
                {
                    title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
                    key: 'updatedAt',
                }];
        },
    },
};




